import React from 'react'
import { Button } from 'reactstrap';
import { DeleteCulture } from './DeleteCulture';
import { FormCulture } from './FormCulture';
import { Dialog } from 'primereact/dialog';

export const ModalCulture = (props) => {

    const {
        modal, modalTitle, closeDialog, method,
        validaciones,
        culture, bacteriums, bacteriumsSelected, onChangeBacterium,
        handleInputChange, loading,
        saveCreate, saveUpdate, saveDelete
    } = props;

    return (
        <Dialog
            visible={modal}
            onHide={closeDialog}
            blockScroll
            closable={false}
            modal
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="icon-panel f-20"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-2`}
            footer={
                <>
                    {
                        method === "create" && <Button
                            color="secondary"
                            onClick={saveCreate}
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                        >
                            {
                                loading ? "Creando bacteria...." : "Crear bacteria"
                            }
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            color="secondary"
                            onClick={saveUpdate}
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                        >
                            {
                                loading ? "Actualizando bacteria...." : "Actualizar bacteria"
                            }
                        </Button>
                    }


                    <Button
                        size="sm"
                        color='danger'
                        type="button"
                        onClick={closeDialog}
                    >
                        Cancelar
                    </Button>

                </>
            }
        >

            {
                method === "create"
                    ? <FormCulture
                        button={"Crear bacteria"}
                        {...{ closeDialog, loading, handleInputChange, validaciones, methodAction: saveCreate, culture, bacteriums, bacteriumsSelected, onChangeBacterium, }}
                    />
                    : (method === "update")
                        ?
                        <FormCulture
                            button={"Actualizar bacteria"}
                            {...{ closeDialog, loading, handleInputChange, validaciones, methodAction: saveUpdate, culture, bacteriums, bacteriumsSelected, onChangeBacterium, }} />
                        :
                        <DeleteCulture {...{ closeDialog, loading, culture, saveDelete }} />
            }
        </Dialog>
    )
}
